import { useEffect, useState } from 'react';
import { jobService } from 'services/job.service';

const usePilotBids = (payload = { skip: 0, limit: 5 }) => {
    const [bids, setBids] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleApi = async () => {
        try {
            setIsLoading(true);
            const response = await jobService.getPilotBids(payload);
            setBids(response.data.data)
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleApi();
    }, [payload]);

    return { bidsObj: bids, isLoading };
}

export default usePilotBids;